import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useCustomFieldCache } from './cache'
import { toResponseError, type CustomFieldRemoveInput, type CustomFieldRemoveSuccess } from '@terros/common'

export function useRemoveCustomField(): RemoveHookResponse<CustomFieldRemoveInput> {
  const cache = useCustomFieldCache()
  const mutation = useTantalimMutation<CustomFieldRemoveInput, CustomFieldRemoveSuccess>({
    url: '/customField/remove',
  })

  async function remove(input: CustomFieldRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearItem(input)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
